require("./threepl-service-action-footer.scss");

import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {bzIconCloseCircle, bzIconCloseCircleOutline, bzIconNote} from "@bringoz/ui/icons";
import {ThreePLServiceDetails} from "../../models/threepl-service-details.model";

@Component({
  selector: "app-threepl-service-action-footer",
  templateUrl: "./threepl-service-action-footer.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceActionFooterComponent {
  readonly selectedServices = input.required<ThreePLServiceDetails[]>();

  readonly addNoteToServices = output<MouseEvent>();
  readonly cancelServices = output<void>();
  readonly unselectAll = output<void>();

  readonly icons = {note: bzIconNote, cancel: bzIconCloseCircleOutline, unselect: bzIconCloseCircle};
}
